export enum CampaignReservationOutcome {
  Reserved = 0,
  NoneAvailable = 1,
  CampaignFinished = 2,
  CampaignNotActive = 3,
}
